import type { FC } from 'react';
import PopFilterButton from './PopFilterButton';
import { useUrlParams } from '../../../../../hooks';
import { useDiscoverStore } from '../../../../../zustand-stores';

const PremierPopFilter: FC = () => {
  const { updateUrlParams } = useUrlParams();

  const premierProgramsOnly = useDiscoverStore(store => store.filters.premierProgramsOnly);

  const handlePress = () =>
    updateUrlParams({ premierProgramsOnly: premierProgramsOnly ? undefined : true });

  return <PopFilterButton onPress={handlePress} label="Premier" pressed={premierProgramsOnly} />;
};

export default PremierPopFilter;
